import React from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "./DefaultCard.css";

const DefaultCard = ({ setSelectedSection,handleSectionChange }) => {


  return (
    <div className="default-message">
      <div className="doassist-card">
        <h2 className="heading">Welcome to DoAssist</h2>
        <p className="description">
          Your AI-powered chat assistant by <span className="highlight">Donyati</span>
        </p>
        <div className="feature-section">
          <div className="feature-card" onClick={() => setSelectedSection("home")}> 
            <h3 className="feature-title">Extensions            
            </h3>
            <p className="feature-description">Create your own extension by using instructions to model or use shared extensions by other users.</p>
          </div>
          <div className="feature-card"  onClick={() => handleSectionChange("publications")}> 
            <h3 className="feature-title">Publications           
            </h3>
            <p className="feature-description">View various chats shared by users.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultCard;
